import { atom } from "recoil";
import { ocPersistAtom } from "oc/states/persist-atom";

export const myCafateriaShowNewStatementItemFormState = atom({
  key: "myCafateriaShowNewStatementItemFormState",
  default: false,
  effects_UNSTABLE: [ocPersistAtom],
});
